import { defineMessages } from "react-intl";

import {
	statusMessages,
	subjectMessages,
	validator
} from "lib/build/forms/ktx/committeeOpinion";

import { FieldData, FieldListData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	committeOpinion: {
		id: "ktx.form.committee_opinion",
		defaultMessage: "Bizottsági vélemény"
	},
	subject: {
		id: "ktx.form.committee_opinion.subject",
		defaultMessage: "Megjegyzés típusa"
	},
	description: {
		id: "ktx.form.committee_opinion.description",
		defaultMessage: "Megjegyzés"
	},
	status: {
		id: "ktx.form.committee_opinion.status",
		defaultMessage: "Páciens státusza"
	},
	assignedUser: {
		id: "ktx.form.committee_opinion.assigned_user",
		defaultMessage: "Véleményező orvos"
	},
	missingForms: {
		id: "ktx.form.committee_opinion.missing_forms",
		defaultMessage: "Hiányzó vizsgálatok"
	},
	neakCheck: {
		id: "ktx.form.committee_opinion.neak_check",
		defaultMessage: "NEAK jogosultság ellenőrzés megtörtént és rendben van"
	}
});

const fields: { [key: string]: FieldData | FieldListData } = {
	subject: {
		type: "field",
		path: ["subject"],
		label: messages.subject,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: subjectMessages } }
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	status: {
		type: "field",
		path: ["status"],
		label: messages.status,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: statusMessages } }
	},
	assignedUser: {
		type: "field",
		path: ["assignedUser"],
		label: messages.assignedUser,
		errorMessages: genericErrorMessages,
		input: { type: "remote-select", props: {} }
	},
	missingForms: {
		type: "field",
		path: ["missingForms"],
		label: messages.missingForms,
		errorMessages: genericErrorMessages,
		input: { type: "remote-multi-select", props: {} }
	},
	neakCheck: {
		type: "field",
		path: ["neakCheck"],
		label: messages.neakCheck,
		errorMessages: genericErrorMessages,
		input: { type: "checkbox", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.subject },
				{ width: 6, field: fields.status }
			]
		},
		{ columns: [{ width: 12, field: fields.assignedUser }] },
		{ columns: [{ width: 12, field: fields.missingForms }] },
		{ columns: [{ width: 12, field: fields.description }] },
		{ columns: [{ width: 12, field: fields.neakCheck }] }
	]
};

export const node: LeafNode = {
	id: "ktx_committeeOpinion",
	value: {
		schemaId: "committeeOpinion",
		title: messages.committeOpinion,
		validator,
		fieldset,
		applyCurrentDate: true,
		showTimeInput: true,
		returnTo: "status-history",
		defaults: [
			{
				path: ["status"],
				query: {
					interpretation: { vocab: "ktx", code: "patient_status" }
				}
			}
		]
	}
};
